// 初期化 (middleware で拾われる必要が無いため、アクション名変更)
export const INIT = "corp/companison/common/INIT";
// 変更
export const CHANGE = "corp/companison/common/CHANGE";
export const RESET = "corp/companison/common/RESET";
